import { useTranslation } from 'react-i18next';

import { DateField, type DateFieldProps } from '../../fields/DateField';
import type { ProjectTasksFormFilerValue } from '../lib/types';

type EndDateFieldProps = Omit<DateFieldProps<ProjectTasksFormFilerValue, 'endDate'>, 'label' | 'name'>;

export const EndDateField = (props: EndDateFieldProps) => {
  const { t } = useTranslation();

  return <DateField {...props} name='endDate' label={t('end-date')} />;
};
